import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import {
  getBottomSpace,
  getStatusBarHeight,
  isIphoneX,
} from 'react-native-iphone-screen-helper';
import { Platform } from 'react-native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Header = styled.View`
  height: ${RFPercentage(25)}px;
  background-color: ${({theme}) => theme.colors.blue};
  padding: 0 24px;
  align-items: flex-end;
  padding-top: ${isIphoneX() ? getStatusBarHeight() : RFValue(20)}px;
`;

export const CloseButton = styled.TouchableOpacity``;

export const CloseButtonIcon = styled(Feather)`
  font-size: ${RFValue(24)}px;
`;

export const Content = styled.View`
  flex: 1;
  align-items: center;
  margin-top: -${RFValue(30)}px;
  padding: 0 24px;
`;

export const IconContainer = styled.View`
  width: ${RFValue(60)}px;
  height: ${RFValue(60)}px;
  background-color: ${({theme}) => theme.colors.background};
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(20)}px;
  border-radius: ${RFValue(16)}px;
`;

export const Icon = styled(Feather)`
  font-size: ${RFValue(30)}px;
  color: ${({theme}) => theme.colors.black};
`;

export const Title = styled.Text`
  text-align: center;
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-bottom: ${RFValue(8)}px;
`;

export const Text = styled.Text`
  text-align: center;
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const Footer = styled.View`
  margin-bottom: ${!isIphoneX() ? RFValue(20) : 0}px;
  padding: 0 24px;
`;

export const LinkButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: ${RFValue(12)}px;
`;

export const SupportContactList = styled.View`
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(8)}px;
`;
export const SupportContactItem = styled.View`
  flex-direction: row;
  margin-bottom: ${RFValue(4)}px;
  align-items: center;
`;
export const SupportContactIcon = styled(Feather)`
  margin-right: ${RFValue(6)}px;
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text};
`;
export const SupportContactText = styled.Text`
  color: ${({theme}) => theme.colors.text};
`;
